module.exports = __webpack_public_path__ + "img/ztxh.a621a4ea.png";